/*jshint esversion: 11 */
import sendApiRequest from '../helpers/axios-setup';

/**
 *
 * @returns {Promise}
 */
export async function getBookList(
  page,
  limit,
  {
    filter_name = '',
    filter_tag_id = '',
    filter_start_age = '',
    filter_end_age = '',
    filter_is_available = '',
    include_deleted = ''
  } = {},
  sorting_option = ''
) {
  try {
    const response = await sendApiRequest.get('/book', {
      params: {
        page: page,
        limit: limit,
        sorting_option: sorting_option,
        filter_name,
        filter_tag_id,
        filter_start_age,
        filter_end_age,
        filter_is_available,
        include_deleted
      }
    });
    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {string} name
 * @param {string} overview
 * @param {string} summary
 * @param {number} age
 * @param {Array} tags
 * @returns {Promise<Object>}
 */
export async function addNewBook(data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.post('/book', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} bookId
 * @returns
 */
export async function getBookInfo(bookId) {
  try {
    const response = await sendApiRequest.get(`/book/${bookId}`);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {string} name
 * @param {string} overview
 * @param {string} summary
 * @param {number} age
 * @param {Array} tags
 * @param {Boolean} isAvailable
 * @returns {Promise<Object>}
 */
export async function updateBook(bookId, data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.put(`/book/${bookId}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} bookId
 * @returns
 */
export async function deleteRestoreBook(bookId, type) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.delete(`/book/${bookId}`, {
      params: {
        type: type
      }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}
